
import Vue from "vue";
import WJsonViewerGroup from "./private/JsonViewerGroup.vue";

export default Vue.extend({
	props: {
		value: {
			required: true,
			type: [Object, Array]
		}
	},
	components: {
		WJsonViewerGroup
	}
});
